import { render } from "./CoinIcon.vue?vue&type=template&id=43cd1ab8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/CoinIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43cd1ab8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43cd1ab8', __exports__)) {
    api.reload('43cd1ab8', __exports__)
  }
  
  module.hot.accept("./CoinIcon.vue?vue&type=template&id=43cd1ab8", () => {
    api.rerender('43cd1ab8', render)
  })

}


export default __exports__